import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import useInitLocalize from './useInitLocalize';
import AuthPageShell, { storeShape } from './components/AuthPageShell';
import AuthLayout from './components/AuthLayout';
import { LOGIN_URL } from './constants';

const ResetSentApp = withLocalize(function ResetSentApp({ initialize, addTranslationForLanguage }) {
    useInitLocalize(initialize, addTranslationForLanguage);
    return (
        <AuthLayout heading="STATIC.PAGES.LOGIN.RESET_HEADING">
            <form className="registration-form" onSubmit={e => { e.preventDefault(); window.location.href = LOGIN_URL; }}>
                <div className="row">
                    <br />
                    <div className="text-center"><Translate id="STATIC.PAGES.LOGIN.RESET_SENT_BODY" /></div>
                </div>
                <button type="submit" className="btn btn-block btn-singular btn-primary password-reset-sent-button">
                    <Translate id="STATIC.PAGES.LOGIN.BACK" />
                </button>
            </form>
        </AuthLayout>
    );
});

export default function ResetSentPage({ store }) {
    return (
        <AuthPageShell store={store}>
            <ResetSentApp />
        </AuthPageShell>
    );
}

ResetSentPage.propTypes = {
    store: storeShape.isRequired,
};
